import $ from "jquery";
import "./util/textWidth";

const adjustNavDropdownsForComingSoon = function (e) {
  const $dropdown = $(e.target).parent().find(".dropdown-content");
  const dropdownWidth = $dropdown.width();
  const $comingSoonTags = $dropdown.find(".coming-soon-tag");
  const comingSoonTagsWidth = $comingSoonTags.width();
  const $menuItems = $comingSoonTags.siblings("a");
  const texts = [];
  for (let i = 0; i < $menuItems.length; i++) {
    texts.push($menuItems[i].innerText);
  }
  let greatestTextWidth = 0;
  for (let i = 0; i < texts.length; i++) {
    const textWidth = $.fn.textWidth(texts[i]);
    if (textWidth > greatestTextWidth) {
      greatestTextWidth = textWidth + 20;
    }
  }
  if (greatestTextWidth > dropdownWidth - comingSoonTagsWidth) {
    $dropdown.width(dropdownWidth + (greatestTextWidth - (dropdownWidth - comingSoonTagsWidth)));
  }
};

$(document).on("turbolinks:load", () => {
  $("nav .dropdown a").on("mouseover", adjustNavDropdownsForComingSoon);
});
